import { LoginMap } from './LoginMap';

/**
 * Decorative login backdrop (z-0). Layers from the maquette:
 * 1) Leaflet map (Pozuelo, deriva ambiental lenta) and on top 2..8) mood
 * overlay, vignette, aurora glows, topographic contours, fine grid, radar
 * rings and an animated ECG line. All non-interactive.
 */
export function LoginBackdrop() {
  return (
    <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
      {/* 1. decorative map (Pozuelo) */}
      <LoginMap />
      {/* 2. mood overlay */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(130% 110% at 78% -10%, rgba(22,163,123,.10) 0%, rgba(255,255,255,.04) 42%, rgba(238,241,239,.30) 78%, rgba(238,241,239,.55) 100%)',
        }}
      />
      {/* 3. vignette */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(95% 85% at 50% 50%, transparent 60%, rgba(180,196,188,.35) 100%)',
        }}
      />
      {/* 4. aurora glows */}
      <div
        className="absolute animate-auroraDrift rounded-full"
        style={{
          width: 780,
          height: 780,
          top: -280,
          right: -180,
          background:
            'radial-gradient(circle, rgba(22,163,123,.18), rgba(22,163,123,0) 62%)',
          filter: 'blur(20px)',
        }}
      />
      <div
        className="absolute animate-auroraDrift2 rounded-full"
        style={{
          width: 620,
          height: 620,
          bottom: -260,
          left: -160,
          background:
            'radial-gradient(circle, rgba(58,160,255,.12), rgba(58,160,255,0) 64%)',
          filter: 'blur(22px)',
        }}
      />
      {/* 5. topographic contours */}
      <svg
        className="absolute inset-0 h-full w-full"
        style={{
          opacity: 0.1,
          maskImage:
            'radial-gradient(95% 80% at 72% 18%, #000 35%, transparent 78%)',
          WebkitMaskImage:
            'radial-gradient(95% 80% at 72% 18%, #000 35%, transparent 78%)',
        }}
        preserveAspectRatio="xMidYMid slice"
        viewBox="0 0 1200 800"
        fill="none"
        stroke="#16a37b"
        strokeWidth={1.1}
      >
        {[0, 60, 120, 180, 240, 300, 360].map((d) => (
          <path
            key={d}
            d={`M-50 ${300 + d} C 200 ${220 + d}, 420 ${360 + d}, 640 ${
              280 + d
            } S 1050 ${200 + d}, 1260 ${300 + d}`}
          />
        ))}
      </svg>
      {/* 6. fine grid */}
      <div
        className="absolute inset-0"
        style={{
          opacity: 0.5,
          backgroundImage:
            'linear-gradient(rgba(22,163,123,.10) 1px, transparent 1px), linear-gradient(90deg, rgba(22,163,123,.10) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
          maskImage:
            'radial-gradient(60% 60% at 12% 88%, #000 0%, transparent 70%)',
          WebkitMaskImage:
            'radial-gradient(60% 60% at 12% 88%, #000 0%, transparent 70%)',
        }}
      />
      {/* 7. radar rings */}
      <div
        className="absolute"
        style={{ top: '13%', right: '15%', width: 240, height: 240 }}
      >
        {[0, 1.3, 2.6].map((delay) => (
          <div
            key={delay}
            className="absolute inset-0 animate-radarPulse rounded-full"
            style={{
              border: '1px solid rgba(22,163,123,.45)',
              animationDelay: `${delay}s`,
            }}
          />
        ))}
        <div
          className="absolute left-1/2 top-1/2 rounded-full"
          style={{
            width: 7,
            height: 7,
            margin: -3.5,
            background: '#16a37b',
            boxShadow: '0 0 12px 3px rgba(22,163,123,.5)',
          }}
        />
      </div>
      {/* 8. ECG line */}
      <svg
        className="absolute left-0 right-0"
        style={{ bottom: '11%', width: '100%', height: 120 }}
        viewBox="0 0 1400 120"
        preserveAspectRatio="none"
        fill="none"
      >
        <path
          d="M0 60 H520 l24 0 14 -40 16 80 14 -64 12 30 18 0 H760 l24 0 14 -40 16 80 14 -64 12 30 18 0 H1400"
          stroke="#16a37b"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray={1400}
          className="animate-ecgMove"
          style={{ filter: 'drop-shadow(0 0 6px rgba(22,163,123,.4))' }}
        />
      </svg>
    </div>
  );
}
